const errorMessageConfig = {
  ERROR_NO_PERMISSION: {
    action: 'onUserLoginAction',
    contents: 'checkout.lib.components.auth.noPermission',
    linkErrorMessage: 'checkout.lib.components.auth.loginAgain',
    showErrorMsgOnly: true,
  },
  ERROR_INVALID_INIT_JWT: {
    action: 'handleInvalidTransactionAction',
    contents: 'checkout.lib.components.transaction.invalid',
    linkErrorMessage: 'checkout.lib.components.transaction.startOver',
    showErrorMsgOnly: true,
  },
  ERROR_INVALID_CONTEXT_JWT: {
    action: 'handleInvalidTransactionAction',
    contents: 'checkout.lib.components.transaction.invalid',
    linkErrorMessage: 'checkout.lib.components.transaction.startOver',
    showErrorMsgOnly: true,
  },
};

export default errorMessageConfig;
